// src/components/Reviews.js
import React from "react";
import Slider from "react-slick";
import reviewsData from "../data/reviews.json"; // Adjust the path as needed

// Helper component to render the star SVGs based on the rating
function StarRating({ rating }) {
  const numStars = parseInt(rating, 10);
  return (
    <div className="star-rating">
      {Array.from({ length: numStars }).map((_, index) => (
        <svg key={index} width="20" height="20" viewBox="0 0 20 20">
          <path
            fill="rgba(251,67,60,1)"
            opacity="1"
            d="M0 4C0 1.79086 1.79086 0 4 0H10V20H4C1.79086 20 0 18.2091 0 16V4Z"
          ></path>
          <path
            fill="rgba(251,67,60,1)"
            opacity="1"
            d="M20 4C20 1.79086 18.2091 0 16 0H10V20H16C18.2091 20 20 18.2091 20 16V4Z"
          ></path>
          <path
            fill="rgba(255,255,255,1)"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 13.3736L12.5949 14.7111C12.7378 14.7848 12.9006 14.8106 13.0593 14.7847C13.4681 14.718 13.7454 14.3325 13.6787 13.9237L13.2085 11.0425L15.2824 8.98796C15.3967 8.8748 15.4715 8.72792 15.4959 8.569C15.5588 8.15958 15.2779 7.77672 14.8685 7.71384L11.983 7.2707L10.6699 4.66338C10.5975 4.51978 10.481 4.40322 10.3374 4.33089C9.96742 4.14458 9.51648 4.29344 9.33017 4.66338L8.01705 7.2707L5.13157 7.71384C4.97265 7.73825 4.82577 7.81309 4.71261 7.92731C4.42109 8.22158 4.42332 8.69645 4.71759 8.98796L6.79152 11.0425L6.32131 13.9237C6.29541 14.0824 6.3212 14.2452 6.39486 14.3881C6.58464 14.7563 7.03696 14.9009 7.40514 14.7111L10 13.3736Z"
          ></path>
        </svg>
      ))}
    </div>
  );
}

function Reviews() {
  const { users } = reviewsData;

  // Settings for one slide per view with autoplay
  const sliderSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
  };

  return (
    <section className="reviews-section">
      <h2>Testimonials</h2>
      <Slider {...sliderSettings}>
        {users.map((user, index) => (
          <div key={index} className="review-slide">
            <div className="review">
              <img
                src={user.Image}
                alt={user.Username}
                className="review-image"
              />
              <p className="review-text">"{user.Review}"</p>
              <p className="review-author">- {user.Username}</p>
              <StarRating rating={user.Stars} />
              <a
                className="review-userlink"
                href={user.Userlink}
                target="_blank"
                rel="noopener noreferrer"
              >
                View on Yelp
              </a>
            </div>
          </div>
        ))}
      </Slider>
      <div className="review-buttons">
        <a
          href="https://www.yelp.com/biz/evergreen-barbershop-san-jose?osq=evergreen+barber+shop"
          target="_blank"
          rel="noopener noreferrer"
        >
          Yelp
        </a>
        <a
          href="https://maps.app.goo.gl/suT2eY7qFtLaQYUWA"
          target="_blank"
          rel="noopener noreferrer"
        >
          Google Reviews
        </a>
      </div>
    </section>
  );
}

export default Reviews;
